import styles from './retrievedTagInfo.module.scss'

export default function RetrievedTagInfo({retrievedTagInfo} = {}) {

  return <div className={styles.limitWidth}>
    <p>פרטי אחזור תג</p>
    {JSON.stringify(retrievedTagInfo)}
  </div>
}
